// extracted by mini-css-extract-plugin
export default {"container":"styles_container__l1-F0","brand":"styles_brand__JEBjX","content":"styles_content__Hy1E3"};